import {
  getDatabaseContainerType,
  analyticsClient,
  SendDatabaseDeleteEntryEventSources,
} from '@databases/analytics';
import {
  InlineRovoPromptTriggerSource,
  openInlineRovoPrompt,
} from '@databases/database-ai-first-creation-state/inline-rovo-prompt-state';
import { type DefaultRootState, type defaultStoreUtils } from '@databases/redux';
import { setHoverDeleteButton } from '@databases/redux/cellSelections/actions';
import { isEntrySelected } from '@databases/redux/cellSelections/selectors';
import { doClearValues, doDeleteEntries } from '@databases/redux/contextual-menu/actions';

import { type SelectValuesActionsAPI } from './select-values-actions';

type UseSelectValuesActionsProps = {
  contentId: string;
  dispatch: ReturnType<typeof defaultStoreUtils.useDispatch>;
  hidePanel: () => void;
  panelEntryId: string;
  state: DefaultRootState;
};

export const buildSelectValuesActionsForLegacyActionBar = ({
  contentId,
  dispatch,
  hidePanel,
  panelEntryId,
  state,
}: UseSelectValuesActionsProps): SelectValuesActionsAPI => {
  const handleClearFields = () => {
    dispatch(doClearValues(contentId));
  };

  const handleDeleteEntries = async () => {
    await analyticsClient.sendDeleteEntryEvent({
      contentId: contentId,
      databaseContainer: getDatabaseContainerType(),
      source: SendDatabaseDeleteEntryEventSources.ACTION_BAR,
    });

    if (isEntrySelected(state, contentId, panelEntryId)) {
      hidePanel();
    }

    dispatch(doDeleteEntries(contentId));
    dispatch(setHoverDeleteButton({ value: null }));
  };

  const handleAskRovo = () =>
    openInlineRovoPrompt(InlineRovoPromptTriggerSource.TableEntry);

  return {
    handleAskRovo,
    handleClearFields,
    handleDeleteEntries,
  };
};
